module.exports = JSON.parse('{"Basic Viewer":"基础查看器","Total Metabolic Tumor Volume":"总代谢肿瘤体积","Download High Quality Image":"A"}')